import React from "react"
import ChoosePlan from "@/components/ChoosePlan"

export default function ChoosePlanView() {
  return <ChoosePlan />
}
